module.exports = __webpack_public_path__ + "img/placeholder-2.03feb1dc.png";